import React from 'react';

import Typography from '@material-ui/core/Typography';

export default ({ configuration }) => {

    function createMarkup(text) {
        return { __html: text };
    }

    if(configuration.footer){

        if(configuration.footer.enabled){
            const ClientFooter = React.lazy(() => import("../" + configuration.footer.component));
            return (
                <React.Suspense>
                    <ClientFooter config={configuration}/>
                </React.Suspense>
            );
        }

        if(configuration.footer.length > 0){
            return configuration.footer.map((item, index) => {
                return (
                    <div key={index} className={"column " + item.class}>
                        {
                            item.title !== ''
                            ?
                            <Typography variant="h6" className="title" gutterBottom>
                                {item.title}
                            </Typography>
                            : null
                        }
                        <div dangerouslySetInnerHTML={createMarkup(item.content)}></div>
                    </div>
                );
            });
        }

    }

    return null;
};